import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom'; // Remove BrowserRouter
import Home from './pages/Home';
import LandingPage from './pages/LandingPage';
import DataUpload from './pages/DataUpload/DataUpload';
import DataUploadChild from './pages/DataUpload/DataUploadChild';
// import Reports from './pages/Reports/Reports';
import LoginPage from './pages/Login/Login'
import ProfilePage from './pages/Profile/profile';
import S3ToS3Upload from './pages/S3ToS3Upload';
import SourceDetailsPage from './pages/S3ToS3Upload/SourceDetailsPage';
import JobDetailsPage from './pages/S3ToS3Upload/JobDetailsPage';
const AppRouter = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/data-upload" element={<DataUpload key={location.pathname} />} />
      <Route path="/data-upload/:datasetId" element={<DataUploadChild />} />
      <Route path="/s3-upload" element={<S3ToS3Upload />} />
      <Route path="/job-details/:jobId" element={<JobDetailsPage />} />
      <Route path="/s3-upload/source/:sourceId" element={<SourceDetailsPage />} />
      {/* <Route path="/report" element={<Reports />} /> */}
      <Route path="/profile" element={<ProfilePage />} />
      {/* Add other routes as needed */}
    </Routes>
  );
};

export default AppRouter;
